// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"452addf8","223":"711e2a22","239":"e39fb35b","431":"df8d5f51","453":"03346f77","455":"5d6dba8c","977":"0296d865"}[chunkId] + ".chunk.js";
};